"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6731],{

/***/ 14825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26447);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27842);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44206);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88433);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6344);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16381);
/* harmony import */ var _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52230);
/* harmony import */ var _config_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87859);
/* harmony import */ var _ui_icons_assets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66023);
/* harmony import */ var _SlideWrapper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47697);
/* eslint-disable react/no-unknown-property */ 











function EngagementSlide() {
    var stackBaseProps = {
        alignItems: {
            xs: "center",
            sm: "start"
        },
        direction: {
            xs: "row",
            sm: "column"
        },
        spacing: 2,
        sx: _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_4__/* .secondaryBox */ .J0
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SlideWrapper__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        sx: {
            justifyContent: "center",
            overflow: "hidden",
            mb: 40
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "h4",
                mt: 4,
                children: "Join the Vesta Community"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                container: true,
                direction: "row",
                justifyContent: "start",
                textAlign: "left",
                spacing: 4,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, stackBaseProps), {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                        size: 38
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[100] */ .w2[100],
                                        children: "Twitter"
                                    })
                                ]
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, stackBaseProps), {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        size: 38
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        mt: 2,
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[100] */ .w2[100],
                                        children: "Medium"
                                    })
                                ]
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, stackBaseProps), {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        size: 38
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "h6",
                                        mt: 2,
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[100] */ .w2[100],
                                        children: "Discord"
                                    })
                                ]
                            }))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "h4",
                mt: 20,
                children: "Engage in Vesta’s Governance"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                container: true,
                direction: "row",
                justifyContent: "start",
                textAlign: "left",
                spacing: 4,
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_4__/* .secondaryBox */ .J0),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        size: 38
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "base",
                                        mt: 2,
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[100] */ .w2[100],
                                        children: "Check out Curia, our Governance Forum!"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_2__/* .NormalLink */ .Yk, {
                            sx: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 2,
                                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, _components_theme_styles_mixins__WEBPACK_IMPORTED_MODULE_4__/* .secondaryBox */ .J0),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_icons_assets__WEBPACK_IMPORTED_MODULE_6__/* .AssetIcon */ .Y, {
                                        noBg: true,
                                        noBorder: true,
                                        asset: _config_types__WEBPACK_IMPORTED_MODULE_5__/* .ENativeAsset.VSTA */ .tx.VSTA,
                                        size: 38
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        variant: "base",
                                        mt: 2,
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .primaryColors[100] */ .w2[100],
                                        children: "Read our Documentation & White Paper!"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EngagementSlide);


/***/ }),

/***/ 28424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27842);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44206);
/* harmony import */ var phosphor_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88433);
/* harmony import */ var _components_shared_divider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38359);
/* harmony import */ var _components_shared_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67113);
/* harmony import */ var _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16381);







var FooterLink = function(param) {
    var href = param.href, title = param.title, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
        href: href,
        sx: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            direction: "row",
            spacing: 2,
            alignItems: "center",
            children: [
                icon ? icon : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "body3",
                    color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                    sx: {
                        transition: "color 0.15s linear",
                        ": hover": {
                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                        }
                    },
                    children: title
                })
            ]
        })
    });
};
var FooterLinkList = function(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        spacing: 3,
        textAlign: "left",
        mt: 8,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                mb: 1,
                variant: "base",
                children: title
            }),
            children
        ]
    });
};
var LandingFooter = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mb: 2,
        sx: {
            px: {
                xs: "32px",
                md: "144px"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            container: true,
            justifyContent: "center",
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "About",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "About Vesta",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Trust & Transparency",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Roadmap",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Learn",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vesta Stable",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Tutorial",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Governance",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Curia Forum",
                                href: ""
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Vote on Snapshot",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Developers",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Documentation",
                                href: "https://docs.vestafinance.xyz/"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Github",
                                href: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLinkList, {
                        title: "Join Us",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                            title: "Careers",
                            href: "https://vesta-finance.notion.site/Open-Roles-on-the-Core-Team-40ce0831db6642b28bdc94d3521372a9"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 6,
                    md: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterLinkList, {
                        title: "Community",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Twitter",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                href: "https://twitter.com/vestafinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Medium",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                                href: "https://medium.com/@VestaFinance"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterLink, {
                                title: "Discord",
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(phosphor_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                href: "https://discord.gg/yKsr6PRtxK"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    mt: 4,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_divider__WEBPACK_IMPORTED_MODULE_2__/* .NormalDivider */ .k4, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            direction: {
                                xs: "column",
                                sm: "row"
                            },
                            mb: 4,
                            mt: 4,
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    direction: "row",
                                    spacing: 4,
                                    justifyContent: "start",
                                    width: "100%",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            variant: "label3",
                                            color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[700] */ .w2[700],
                                            children: "PROUD CREATION OF MAXIMUS LABS"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            href: "https://docs.google.com/document/d/e/2PACX-1vR35fS4nqisK3TMMmULwrZBqRu-ujqShbrZU_3KeqU51yGWe_lQtqCFAoIC1Lg5f67n4mDKYbsbZ093/pub",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "TERMS OF SERVICE"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_link__WEBPACK_IMPORTED_MODULE_3__/* .NormalLink */ .Yk, {
                                            href: "https://docs.google.com/document/d/e/2PACX-1vRAewaErhuxxT6Hxss_3IWNVw3-PlByipiDIXYwNhfVF0EDEp0CGbBPSjSzN9JHbmafM5BtU0KOf0w0/pub",
                                            sx: {
                                                textDecoration: "none"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sx: {
                                                    transition: "color 0.15s linear",
                                                    ": hover": {
                                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[400] */ .w2[400]
                                                    }
                                                },
                                                variant: "label3",
                                                color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .primaryColors[900] */ .w2[900],
                                                children: "PRIVACY POLICY"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    variant: "h6",
                                    sx: {
                                        color: _components_theme_styles_colors__WEBPACK_IMPORTED_MODULE_4__/* .white["15%"] */ .ix["15%"],
                                        display: "flex",
                                        gap: "1em",
                                        justifyContent: "space-around",
                                        textAlign: "center",
                                        mt: {
                                            xs: 4,
                                            sm: 0
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "V"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "E"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "S"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "T"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "A"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingFooter);


/***/ }),

/***/ 47697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99226);




var SlideWrapper = function(param) {
    var children = param.children, sx = param.sx, onMouseMove = param.onMouseMove;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        onMouseMove: onMouseMove,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            backgroundSize: "cover",
            px: {
                xs: "32px",
                md: "144px"
            },
            height: "100%",
            mb: 40
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlideWrapper);


/***/ }),

/***/ 41394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FadeContainer; }
/* harmony export */ });
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99226);

var FadeContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var visible = param.visible, time = param.time;
    return {
        opacity: visible ? 1 : 0,
        transition: "opacity ".concat(time, "s ease")
    };
});


/***/ })

}]);